var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.969,
    height: 15.773,
    viewBox: "0 0 15.969 15.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-history",
    "data-name": "Icon akar-history",
    d: "M3.968,12.983A6.821,6.821,0,0,0,6.96,16.024a6.655,6.655,0,0,0,4.182.636,6.723,6.723,0,0,0,3.736-2.018A6.975,6.975,0,0,0,15.9,6.532a6.805,6.805,0,0,0-3.11-2.916,6.65,6.65,0,0,0-4.2-.465A6.319,6.319,0,0,0,5.059,5.257a5.875,5.875,0,0,0-.933,1.361m2.313.2-2.759.55L3,4.529M9.879,7.586v3.058l2.293,1.529",
    transform: "translate(-1.795 -1.992)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.313fd1914c5780f4d4b2c5971e639fd9.svg";
export { ForwardRef as ReactComponent };